import { useQuery } from '@tanstack/react-query'
import { fetchBusinessDashboardSummary } from '../../dashboard/api'
import { OWNER_ONBOARDING_STEPS } from '../lib/steps'

export function useOwnerOnboardingSteps() {
  const { data, isLoading } = useQuery({
    queryKey: ['dashboard', 'business-summary'],
    queryFn: fetchBusinessDashboardSummary,
  })

  const state = data?.data.onboarding

  if (!state) {
    return {
      steps: OWNER_ONBOARDING_STEPS.map((s) => ({ ...s, completed: false })),
      completedCount: 0,
      totalCount: OWNER_ONBOARDING_STEPS.length,
      allComplete: false,
      isLoading,
    }
  }

  const steps = OWNER_ONBOARDING_STEPS.map((s) => ({
    ...s,
    completed: s.isComplete(state),
  }))

  const completedCount = steps.filter((s) => s.completed).length

  return {
    steps,
    completedCount,
    totalCount: steps.length,
    allComplete: completedCount === steps.length,
    isLoading,
  }
}
